export default "<ul class=\"Example\">\n  {{#each items 'another' hashValue=false}}\n  <li>Whoa!!</li>\n  {{/each}}\n</ul>\n";